@if (owners.length > 1) {
  <div ngClass="{{ index == 0 ? 'tap-main' : 'tap-spouse' }}">
    <span class="tap-text">
      {{ owner.get('userFirstName')?.value }}
      {{ owner.get('userLastName')?.value }}
    </span>
  </div>
}
